import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { chatApi } from '@/api/chat';

/**
 * Резолвим беседу по активному lease (get-or-create на бэкенде идемпотентен).
 * POST в queryFn — нормально: метод идемпотентный, кэшируем по leaseId.
 */
export function useConversation(leaseId: number | null) {
  return useQuery({
    queryKey: ['chat', 'conversation', leaseId],
    queryFn: () => chatApi.createConversation(leaseId as number),
    enabled: leaseId !== null,
  });
}

export function useMessages(conversationId: number | null) {
  return useQuery({
    queryKey: ['chat', 'messages', conversationId],
    queryFn: () => chatApi.listMessages(conversationId as number),
    enabled: conversationId !== null,
  });
}

export function useSendMessage(conversationId: number) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (content: string) => chatApi.sendMessage(conversationId, content),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['chat', 'messages', conversationId] });
    },
  });
}
